import { Group, Stack, Text } from "@mantine/core"
import { IconCircleNumber1, IconCircleNumber2 } from "@tabler/icons-react"

export const DocsStep2AutoSplit = () => {
  return (
    <>
      <Group gap="xs" mb="xs">
        <IconCircleNumber2 size={40} />
        <Text fw={500}>
          Choose how to map the metric dimensions to the virtual dimensions
          values:
        </Text>
      </Group>
      <Stack gap="2">
        <Text fw={100} c="dimmed">
          3 modes are available:
        </Text>
        <Text fw={100} c="dimmed">
          - Identity Mapping: The vdim value is the metric dimension.
        </Text>
        <Text fw={100} c="dimmed">
          - Regex Mapping: The vdim value is the result of the regex pattern
          applied to the metric dimension.
        </Text>
        <Text fw={100} c="dimmed">
          - Manual Mapping: The vdim value is mapped to the dimension value you
          choose.
        </Text>
      </Stack>
    </>
  )
}

export const DocsStep1AutoSplit = () => {
  return (
    <>
      <Group gap="xs" mb="xs">
        <IconCircleNumber1 size={40} />
        <Text fw={500}>Choose usage metric for allocation:</Text>
        <Text fw={100} c="dimmed">
          The metric will be used to allocate the usage to the dimension values
          proportionnally. For example SUM(queryTime) of a db per username will
          spread the cost proportionnally to the number of queries per username.
        </Text>
      </Group>
    </>
  )
}
